import styled from "styled-components";

const ACCENTS: Record<string, string> = {
  orange: "#f59e0b",
  violet: "#8b5cf6",
  emerald: "#10b981",
  sky: "#0ea5e9",
  indigo: "#6366f1",
  zinc: "#71717a",
};

export const Container = styled.div<{ $accent?: keyof typeof ACCENTS }>`
  --accent: ${({ $accent }) => ($accent ? ACCENTS[$accent] : ACCENTS.zinc)};
  position: relative;

  min-width: 180px;
  width: 100%;
  padding: 14px 16px 12px 16px;

  background: linear-gradient(
        90deg,
        color-mix(in srgb, var(--accent), #ffffff 30%) 0%,
        var(--accent) 18%,
        var(--accent) 82%,
        color-mix(in srgb, var(--accent), #ffffff 30%) 100%
      )
      top / 100% 3px no-repeat,
    #ffffff;
  border: 1px solid #e5e7eb;
  border-top-color: transparent;
  border-radius: 14px;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.06);

  overflow: hidden;

  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto auto auto;
  grid-column-gap: 10px;
  align-items: start;

  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    transform 0.12s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: #cbd5e1; /* slate-300 */
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  }

  &:focus-within {
    outline: 2px solid color-mix(in srgb, var(--accent), #000 15%);
    outline-offset: 2px;
  }
`;

export const IconWrap = styled.div`
  grid-row: 1 / span 2;
  grid-column: 1;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: color-mix(in srgb, var(--accent), #ffffff 82%);
  color: color-mix(in srgb, var(--accent), #000 20%);
  display: grid;
  place-items: center;
  margin-top: 2px;

  svg {
    stroke: currentColor;
  }
`;

export const Tag = styled.div`
  grid-column: 2 / span 2;
  align-self: center;

  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.2px;
`;

export const Data = styled.div`
  grid-column: 2 / span 2;

  display: flex;
  align-items: baseline;
  gap: 8px;

  .value {
    font-size: 20px;
    font-weight: 800;
    color: #0f172a;
    line-height: 1.2;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Unit = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #94a3b8;
  padding: 2px 6px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f8fafc;
`;

export const Hint = styled.div`
  grid-column: 2 / span 2;
  font-size: 11px;
  color: #94a3b8; /* slate-400 */
  margin-top: 2px;
`;
